// extracted by mini-css-extract-plugin
export default {"desc":"AlertModal_desc_Dyqx4"};